import { ShipmentStatus } from 'src/types/shipments'

import { formatDayShortMonthDate } from 'src/routes/(registry)/registry/(gift-tracker-revamp)/utils'

const shipmentStatusRelevantDate = ({
  currentState,
  estimatedShippingDate,
  estimatedDeliveryDate: { maxDate: estimatedDeliveryDate },
  deliveredAt,
}: ShipmentStatus) => {
  if (
    !currentState ||
    currentState == 'cancelled' ||
    currentState == 'unknown'
  ) {
    return null
  }

  return {
    processing: estimatedShippingDate,
    preparing: estimatedShippingDate,
    shipped: estimatedDeliveryDate,
    delivered: deliveredAt,
  }[currentState]
}

const shipmentStatusLabel = ({ currentState }: ShipmentStatus) => {
  if (
    !currentState ||
    currentState === 'cancelled' ||
    currentState === 'unknown'
  ) {
    return null
  }

  return {
    processing: 'Estimated to ship',
    preparing: 'Estimated to ship',
    shipped: 'Estimated delivery on',
    delivered: 'Delivered on',
  }[currentState]
}

export const shipmentStatusLabelAndInfo = (shipmentStatus: ShipmentStatus) => {
  const relevantDate = shipmentStatusRelevantDate(shipmentStatus)

  if (!relevantDate) {
    return null
  }

  return {
    label: shipmentStatusLabel(shipmentStatus),
    info: formatDayShortMonthDate(relevantDate),
  }
}
